import React from 'react';

// Formik validation
import { useFormik } from "formik";
import { Button, Container, Form, Modal } from 'reactstrap';
import * as Yup from "yup";
import { GradientDecorationLine, BaseCustomButton, BaseCustomModal, BaseSelectComponent } from '../../../../../shared';

export const LabCitecDetailsTestEditModal = ({ props, setShowModal, icon, showModal, modalHeader, modalRespInfo, rowInfo, /* extraRender */ }) => {

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            statusTest: rowInfo?.statusTest,
        },
        validationSchema: Yup.object({
            statusTest: Yup.string().required("Seleccione un estatus"),
        }),
        onSubmit: (values, { resetForm }) => {
            modalRespInfo(values);
            resetForm();
            setShowModal(false);
        }
    });

    const { className } = props;

    const toggle = () => {
        setShowModal(!showModal);
    }

    const onClosed = () => {
        validation.resetForm();
        setShowModal(false);
    }

    const statusOptions = [
        { value: 'Pendiente', label: 'Pendiente' },
        { value: 'Rechazado', label: 'Rechazado' },
        { value: 'Autorizado', label: 'Autorizado' }
    ];

    const buttons = (
        <div className="page-title-box d-flex justify-content-end">
            <BaseCustomButton
                color="success"
                label="Guardar"
                onClick={validation.handleSubmit}
                outline
                className="rounded-3 me-3 p-2"
                icon="mdi mdi-content-save me-1"
            />
            <BaseCustomButton
                color="danger"
                label="Cancelar"
                onClick={toggle}
                outline
                className="rounded-3 p-2"
                icon="mdi mdi-close-circle me-1"
            />
        </div>
    );

    const children_body = (
        <div className='w-100 me-3'>
            <label htmlFor="exampleInputEmail1" className='text-primary'>Estatus</label>
            <BaseSelectComponent
                options={statusOptions}
                value={validation.values.statusTest}
                onChange={value => validation.setFieldValue('statusTest', value)}
                placeholder="Seleccionar Estatus"
                error={validation.errors.statusTest}
                touched={validation.errors.statusTest}
                status={validation.errors.statusTest ? 'error' : ''}
            />
            {validation.errors.statusTest && validation.touched.statusTest && (
                <div className="text-danger">{validation.errors.statusTest}</div>
            )}
        </div>
    );

    const modalTitle = icon === 'warning' 
    ? (
        <div className='d-flex align-items-center justify-content-center'>
            <span className="mdi mdi-alert-outline mdi-36px text-warning ps-4 m-0"></span>
            <h4 className='text-primary m-0 ps-1'>{modalHeader}</h4>
        </div>
    )
    : <h4 className='text-primary ps-4 m-0'>{modalHeader}</h4>;

    return (
        <> 
            <BaseCustomModal
                title={modalTitle}
                onClosed={onClosed}
                isModalOpen={showModal}
                handleOk={validation.handleSubmit}
                handleCancel={toggle}
                footer={null}
            >
                <GradientDecorationLine />
                {children_body}
                <GradientDecorationLine />
                {buttons}
            </BaseCustomModal>
        </>
    )
}
